import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_PERSON_IN_INCIDENT = gql`
  mutation addOrUpdatePersonInIncident(
    $input: AddOrUpdatePersonInIncidentInput!
  ) {
    addOrUpdatePersonInIncident(input: $input) {
      incidentUuid
      personIncidentSpecificUuid
      personUuid
      personIncidentSpecific {
        id
        uuid
        incident {
          id
        }
        yoe
        juvenile
        person {
          aliases {
            id
            target {
              id
              personalAttribute {
                firstName
                middleName
                lastName
              }
              validPersonAlerts {
                id
                notes
                alertType {
                  name
                  alertLevel
                }
              }
            }
          }
          id
          genericAttachments {
            attachmentType {
              id
              name
            }
            incident {
              id
              ori {
                id
              }
            }
            confidential
            dataFileName
            dataUrl
            dataUrlWrapper
            description
            employee {
              id
              personalAttribute {
                lastName
                firstName
              }
              deptAttribute {
                badge
                ori {
                  id
                  abbreviation
                }
              }
            }
            id
            lastUpdated
            ownerName
          }
          validPersonAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            officerId
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            person {
              id
            }
          }
          personalAttribute {
            aliasName
            bilingual
            buildType {
              id
              name
              oriId
              position
              __typename
            }
            cell
            deceased
            distinguishingCharacteristics
            dob
            driversLicense
            email
            employer
            employerAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            eyeColor {
              id
              name
              oriId
              position
              __typename
            }
            facialHairType {
              id
              name
              oriId
              position
              __typename
            }
            fbiNumber
            firstName
            fishWildlifeLicense
            gender {
              id
              name
              oriId
              position
              __typename
            }
            hairColor {
              id
              name
              oriId
              position
              __typename
            }
            hairLength {
              id
              name
              oriId
              position
              __typename
            }
            height
            homeAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
                id
                notes
              }
              __typename
            }
            ibrArresteeRaceType {
              id
              name
              oriId
              position
              __typename
            }
            id
            juvenile
            lastName
            licenseState {
              id
              name
              oriId
              position
              __typename
            }
            mailingAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            mentalHealthAlert
            middleName
            nibrsGender {
              id
              name
              oriId
              position
              __typename
            }
            notes
            organization
            phone
            pobAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              __typename
            }
            race {
              id
              name
              oriId
              position
              __typename
            }
            residentType {
              id
              name
              oriId
              position
              __typename
            }
            sid
            substanceAbuseAlert
            suffix
            violenceAlert
            waiverFine
            weaponsAlert
            weight
            work
            __typename
          }
        }
        incidentInvolvement {
          id
          name
          oriId
          position
        }
      }
      errors
    }
  }
`;
